// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list_type {\n  list-style-type: disc !important;\n}\n", "",{"version":3,"sources":["webpack://src/pages/footerpages/footer.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;AAClC","sourcesContent":[".list_type {\n  list-style-type: disc !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
